import HeroBanner from './HeroBanner';
import MarketTicker from './MarketTicker';
import StatsGrid from './StatsGrid';
import DashboardPanels from './DashboardPanels';

function Sections() {
  return (
    <main className="sections">
      <HeroBanner />
      <MarketTicker />
      <StatsGrid />
      <DashboardPanels />
    </main>
  );
}

export default Sections;
